module.exports = __webpack_public_path__ + "img/product.0f6e3058.png";